import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Spin,
} from 'antd';
import _ from 'lodash';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import BreadCrumbs from '../../../../common/components/Breadcrumbs';
import { validateMessages } from '../../../../common/constants/common';
import { Page } from '../../../../common/constants/pageAction';
import {
  forDisableDate,
  forEditModal,
  getObjectForUpdateMultiple,
  getSimpleDate,
  passDateToApi,
} from '../../../../common/helperFunction';
import { IInlineSearch } from '../../../../common/models/common';
import { ILookup } from '../../../../services/common/common.model';
import { IO365CopilotUsage } from '../../../../services/o365/o365-copilot-usage/o365-copilot-usage.model';
import { useAppSelector, useAppDispatch } from '../../../../store/app.hooks';
import {
  getBULookup,
  getCompanyLookup,
  getTenantLookup,
  updateMultiple,
} from '../../../../store/common/common.action';
import {
  clearBULookUp,
  clearCompanyLookUp,
  clearMultipleUpdateMessages,
  commonSelector,
} from '../../../../store/common/common.reducer';
import { globalSearchSelector } from '../../../../store/globalSearch/globalSearch.reducer';
import {
  getO365CopilotUsageById,
  saveO365CopilotUsage,
} from '../../../../store/o365/o365-copilot-usage/o365-copilot-usage.action';
import {
  clearO365CopilotUsageGetById,
  clearO365CopilotUsageMessages,
  o365CopilotUsageSelector,
} from '../../../../store/o365/o365-copilot-usage/o365-copilot-usage.reducer';
import { IAddO365CopilotUsageProps } from './addO365CopilotUsage.model';

const { Option } = Select;

const disabledDate = forDisableDate();

const AddO365CopilotUsageModal: React.FC<IAddO365CopilotUsageProps> = (props) => {
  const o365CopilotUsage = useAppSelector(o365CopilotUsageSelector);
  const commonLookups = useAppSelector(commonSelector);
  const dispatch = useAppDispatch();
  const globalFilters = useAppSelector(globalSearchSelector);

  const { id, showModal, handleModalClose, refreshDataTable, isMultiple, valuesForSelection } = props;

  const isNew: boolean = id || isMultiple ? false : true;
  const title = useMemo(() => {
    return (
      <>
        {isNew ? 'Add ' : 'Edit '} <BreadCrumbs pageName={Page.O365CopilotUsage} level={1} />
      </>
    );
  }, [isNew]);
  const submitButtonText = useMemo(() => {
    return isNew ? 'Save' : 'Update';
  }, [isNew]);

  const [form] = Form.useForm();

  let initialValues: IO365CopilotUsage = {
    tenant_id: null,
    company_id: null,
    bu_id: null,
    report_refresh_date: null,
    user_principal_name: '',
    display_name: '',
    last_activity_date: null,
    report_period: null,
    prompts_submitted_for_all_apps: null,
    prompts_submitted_for_copilot_chat_work: null,
    prompts_submitted_for_copilot_chat_web: null,
    active_usage_days_for_all_apps: null,
    last_activity_date_of_copilot_chat_work_utc: null,
    last_activity_date_of_copilot_chat_web_utc: null,
    last_activity_date_of_teams_copilot_utc: null,
    last_activity_date_of_word_copilot_utc: null,
    last_activity_date_of_excel_copilot_utc: null,
    last_activity_date_of_powerpoint_copilot_utc: null,
    last_activity_date_of_outlook_copilot_utc: null,
    last_activity_date_of_onenote_copilot_utc: null,
    last_activity_date_of_loop_copilot_utc: null,
    last_activity_date_of_microsoft_365_copilot_app_utc: null,
    last_activity_date_of_edge_utc: null,
    last_activity_date_of_copilot_agent_utc: null,
    date_added: getSimpleDate(),
  };

  const onFinish = (values: any) => {
    const inputValues: IO365CopilotUsage = {
      ...values,
      id: id ? +id : null,
    };
    inputValues.report_refresh_date = passDateToApi(inputValues.report_refresh_date, true);
    inputValues.last_activity_date = passDateToApi(inputValues.last_activity_date, true);
    inputValues.last_activity_date_of_copilot_chat_work_utc = passDateToApi(inputValues.last_activity_date_of_copilot_chat_work_utc, true);
    inputValues.last_activity_date_of_copilot_chat_web_utc = passDateToApi(inputValues.last_activity_date_of_copilot_chat_web_utc, true);
    inputValues.last_activity_date_of_teams_copilot_utc = passDateToApi(inputValues.last_activity_date_of_teams_copilot_utc, true);
    inputValues.last_activity_date_of_word_copilot_utc = passDateToApi(inputValues.last_activity_date_of_word_copilot_utc, true);
    inputValues.last_activity_date_of_excel_copilot_utc = passDateToApi(inputValues.last_activity_date_of_excel_copilot_utc, true);
    inputValues.last_activity_date_of_powerpoint_copilot_utc = passDateToApi(inputValues.last_activity_date_of_powerpoint_copilot_utc, true);
    inputValues.last_activity_date_of_outlook_copilot_utc = passDateToApi(inputValues.last_activity_date_of_outlook_copilot_utc, true);
    inputValues.last_activity_date_of_onenote_copilot_utc = passDateToApi(inputValues.last_activity_date_of_onenote_copilot_utc, true);
    inputValues.last_activity_date_of_loop_copilot_utc = passDateToApi(inputValues.last_activity_date_of_loop_copilot_utc, true);
    inputValues.last_activity_date_of_microsoft_365_copilot_app_utc = passDateToApi(inputValues.last_activity_date_of_microsoft_365_copilot_app_utc, true);
    inputValues.last_activity_date_of_edge_utc = passDateToApi(inputValues.last_activity_date_of_edge_utc, true);
    inputValues.last_activity_date_of_copilot_agent_utc = passDateToApi(inputValues.last_activity_date_of_copilot_agent_utc, true);
    inputValues.date_added = passDateToApi(inputValues.date_added, true);

    if (!isMultiple) {
      dispatch(saveO365CopilotUsage(inputValues));
    } else {
      const result = getObjectForUpdateMultiple(
        valuesForSelection,
        inputValues,
        o365CopilotUsage.search.tableName
      );
      if (result) {
        dispatch(updateMultiple(result));
      }
    }
  };

  const handleTenantChange = (tenantId: number) => {
    form.setFieldsValue({ tenant_id: tenantId, company_id: null, bu_id: null });
    if (tenantId) {
      dispatch(getCompanyLookup(tenantId));
      dispatch(clearBULookUp());
    } else {
      dispatch(clearCompanyLookUp());
      dispatch(clearBULookUp());
    }
  };

  const handleCompanyChange = (companyId: number) => {
    form.setFieldsValue({ company_id: companyId, bu_id: null });
    if (companyId) {
      dispatch(getBULookup(companyId));
    } else {
      dispatch(clearBULookUp());
    }
  };

  const handleBUChange = (buId: number) => {
    form.setFieldsValue({ bu_id: buId });
  };

  const fillValuesOnEdit = async (data: IO365CopilotUsage) => {
    if (data.tenant_id) {
      await dispatch(getCompanyLookup(data.tenant_id));
    }
    if (data.company_id) {
      await dispatch(getBULookup(data.company_id));
    }
    if (data) {
      initialValues = {
        tenant_id: _.isNull(data.tenant_id) ? null : data.tenant_id,
        company_id: _.isNull(data.company_id) ? null : data.company_id,
        bu_id: _.isNull(data.bu_id) ? null : data.bu_id,
        report_refresh_date: _.isNull(data.report_refresh_date) ? null : forEditModal(data.report_refresh_date),
        user_principal_name: data.user_principal_name,
        display_name: data.display_name,
        last_activity_date: _.isNull(data.last_activity_date) ? null : forEditModal(data.last_activity_date),
        report_period: data.report_period,
        prompts_submitted_for_all_apps: data.prompts_submitted_for_all_apps,
        prompts_submitted_for_copilot_chat_work: data.prompts_submitted_for_copilot_chat_work,
        prompts_submitted_for_copilot_chat_web: data.prompts_submitted_for_copilot_chat_web,
        active_usage_days_for_all_apps: data.active_usage_days_for_all_apps,
        last_activity_date_of_copilot_chat_work_utc: _.isNull(data.last_activity_date_of_copilot_chat_work_utc) ? null : forEditModal(data.last_activity_date_of_copilot_chat_work_utc),
        last_activity_date_of_copilot_chat_web_utc: _.isNull(data.last_activity_date_of_copilot_chat_web_utc) ? null : forEditModal(data.last_activity_date_of_copilot_chat_web_utc),
        last_activity_date_of_teams_copilot_utc: _.isNull(data.last_activity_date_of_teams_copilot_utc) ? null : forEditModal(data.last_activity_date_of_teams_copilot_utc),
        last_activity_date_of_word_copilot_utc: _.isNull(data.last_activity_date_of_word_copilot_utc) ? null : forEditModal(data.last_activity_date_of_word_copilot_utc),
        last_activity_date_of_excel_copilot_utc: _.isNull(data.last_activity_date_of_excel_copilot_utc) ? null : forEditModal(data.last_activity_date_of_excel_copilot_utc),
        last_activity_date_of_powerpoint_copilot_utc: _.isNull(data.last_activity_date_of_powerpoint_copilot_utc) ? null : forEditModal(data.last_activity_date_of_powerpoint_copilot_utc),
        last_activity_date_of_outlook_copilot_utc: _.isNull(data.last_activity_date_of_outlook_copilot_utc) ? null : forEditModal(data.last_activity_date_of_outlook_copilot_utc),
        last_activity_date_of_onenote_copilot_utc: _.isNull(data.last_activity_date_of_onenote_copilot_utc) ? null : forEditModal(data.last_activity_date_of_onenote_copilot_utc),
        last_activity_date_of_loop_copilot_utc: _.isNull(data.last_activity_date_of_loop_copilot_utc) ? null : forEditModal(data.last_activity_date_of_loop_copilot_utc),
        last_activity_date_of_microsoft_365_copilot_app_utc: _.isNull(data.last_activity_date_of_microsoft_365_copilot_app_utc) ? null : forEditModal(data.last_activity_date_of_microsoft_365_copilot_app_utc),
        last_activity_date_of_edge_utc: _.isNull(data.last_activity_date_of_edge_utc) ? null : forEditModal(data.last_activity_date_of_edge_utc),
        last_activity_date_of_copilot_agent_utc: _.isNull(data.last_activity_date_of_copilot_agent_utc) ? null : forEditModal(data.last_activity_date_of_copilot_agent_utc),
        date_added: _.isNull(data.date_added) ? null : forEditModal(data.date_added),
      };
      form.setFieldsValue(initialValues);
    }
  };

  useEffect(() => {
    if (o365CopilotUsage.save.messages.length > 0) {
      if (o365CopilotUsage.save.hasErrors) {
        toast.error(o365CopilotUsage.save.messages.join(' '));
      } else {
        toast.success(o365CopilotUsage.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearO365CopilotUsageMessages());
    }
  }, [o365CopilotUsage.save.messages]);

  useEffect(() => {
    if (commonLookups.save.messages.length > 0) {
      if (commonLookups.save.hasErrors) {
        toast.error(commonLookups.save.messages.join(' '));
      } else {
        toast.warn(commonLookups.save.messages.join(' '));
        handleModalClose();
      }
      dispatch(clearMultipleUpdateMessages());
    }
  }, [commonLookups.save.messages]);

  useEffect(() => {
    if (+id > 0 && o365CopilotUsage.getById.data) {
      const data = o365CopilotUsage.getById.data;
      fillValuesOnEdit(data);
    }
  }, [o365CopilotUsage.getById.data]);

  useEffect(() => {
    if (Object.keys(globalFilters?.globalTenantLookup?.data).length == 0) {
      dispatch(getTenantLookup());
    }
    if (+id > 0) {
      dispatch(getO365CopilotUsageById(+id));
    }
    return () => {
      dispatch(clearO365CopilotUsageGetById());
      dispatch(clearCompanyLookUp());
      dispatch(clearBULookUp());
    };
  }, [dispatch]);

  useEffect(() => {
    if (+id === 0 && !isMultiple) {
      const globalSearch: IInlineSearch = {};
      for (const key in globalFilters.search) {
        const element = globalFilters.search[key];
        globalSearch[key] = element ? [element] : null;
      }
      if (globalFilters.search.tenant_id && globalFilters.search.tenant_id !== 0) {
        if (!globalFilters.search.company_id) {
          dispatch(getCompanyLookup(globalSearch.tenant_id[0]));
        }
        if (!globalFilters.search.bu_id && globalFilters.search.company_id !== 0) {
          dispatch(getBULookup(globalSearch.company_id[0]));
        }
        const initlValues = {
          company_id: _.isNull(globalSearch.company_id) ? null : globalSearch.company_id[0],
          bu_id: _.isNull(globalSearch.bu_id) ? null : globalSearch.bu_id[0],
          tenant_id: _.isNull(globalSearch.tenant_id) ? null : globalSearch.tenant_id[0],
        };
        form.setFieldsValue(initlValues);
      }
    }
  }, []);

  return (
    <>
      <Modal
        wrapClassName="custom-modal"
        title={title}
        centered
        visible={showModal}
        onCancel={handleModalClose}
        footer={false}
      >
        {o365CopilotUsage.getById.loading ? (
          <div className="spin-loader">
            <Spin spinning={o365CopilotUsage.getById.loading} />
          </div>
        ) : (
          <Form
            form={form}
            name="addO365CopilotUsage"
            initialValues={initialValues}
            onFinish={onFinish}
            validateMessages={validateMessages}
          >
            <Row gutter={[30, 15]} className="form-label-hide">
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'tenant_id']} valuePropName="checked" noStyle>
                      <Checkbox>Tenant</Checkbox>
                    </Form.Item>
                  ) : (
                    'Tenant'
                  )}
                  <Form.Item
                    name="tenant_id"
                    className="m-0"
                    label="Tenant"
                    rules={[{ required: !isMultiple }]}
                  >
                    <Select
                      onChange={handleTenantChange}
                      loading={commonLookups.tenantLookup.loading}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA: any, optionB: any) =>
                        optionA.children
                          ?.toLowerCase()
                          ?.localeCompare(optionB.children?.toLowerCase())
                      }
                    >
                      {Object.keys(globalFilters?.globalTenantLookup?.data).length > 0
                        ? globalFilters?.globalTenantLookup?.data.map((option: ILookup) => (
                            <Option key={option.id} value={option.id}>
                              {option.name}
                            </Option>
                          ))
                        : commonLookups.tenantLookup.data.map((option: ILookup) => (
                            <Option key={option.id} value={option.id}>
                              {option.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'company_id']} valuePropName="checked" noStyle>
                      <Checkbox>Company</Checkbox>
                    </Form.Item>
                  ) : (
                    'Company'
                  )}
                  <Form.Item name="company_id" className="m-0" label="Company">
                    <Select
                      onChange={handleCompanyChange}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA: any, optionB: any) =>
                        optionA.children
                          ?.toLowerCase()
                          ?.localeCompare(optionB.children?.toLowerCase())
                      }
                      loading={commonLookups.companyLookup.loading}
                    >
                      {Object.keys(commonLookups.companyLookup.data).length > 0
                        ? commonLookups.companyLookup.data.map((option: ILookup) => (
                            <Option key={option.id} value={option.id}>
                              {option.name}
                            </Option>
                          ))
                        : globalFilters?.globalCompanyLookup?.data.map((option: ILookup) => (
                            <Option key={option.id} value={option.id}>
                              {option.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'bu_id']} valuePropName="checked" noStyle>
                      <Checkbox>BU</Checkbox>
                    </Form.Item>
                  ) : (
                    'BU'
                  )}
                  <Form.Item name="bu_id" className="m-0" label="BU">
                    <Select
                      onChange={handleBUChange}
                      loading={commonLookups.buLookup.loading}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA: any, optionB: any) =>
                        optionA.children
                          ?.toLowerCase()
                          ?.localeCompare(optionB.children?.toLowerCase())
                      }
                    >
                      {Object.keys(commonLookups.buLookup.data).length > 0
                        ? commonLookups.buLookup.data.map((option: ILookup) => (
                            <Option key={option.id} value={option.id}>
                              {option.name}
                            </Option>
                          ))
                        : globalFilters?.globalBULookup?.data.map((option: ILookup) => (
                            <Option key={option.id} value={option.id}>
                              {option.name}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'report_refresh_date']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Report Refresh Date</Checkbox>
                    </Form.Item>
                  ) : (
                    'Report Refresh Date'
                  )}
                  <Form.Item name="report_refresh_date" label="Report Refresh Date" className="m-0">
                    <DatePicker className="form-control w-100" />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'user_principal_name']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>User Principal Name</Checkbox>
                    </Form.Item>
                  ) : (
                    'User Principal Name'
                  )}
                  <Form.Item
                    name="user_principal_name"
                    label="User Principal Name"
                    className="m-0"
                    rules={[{ max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'display_name']} valuePropName="checked" noStyle>
                      <Checkbox>Display Name</Checkbox>
                    </Form.Item>
                  ) : (
                    'Display Name'
                  )}
                  <Form.Item
                    name="display_name"
                    className="m-0"
                    label="Display Name"
                    rules={[{ max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity Date</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity Date'
                  )}
                  <Form.Item name="last_activity_date" label="Last Activity Date" className="m-0">
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'report_period']} valuePropName="checked" noStyle>
                      <Checkbox>Report Period</Checkbox>
                    </Form.Item>
                  ) : (
                    'Report Period'
                  )}
                  <Form.Item
                    name="report_period"
                    label="Report Period"
                    className="m-0"
                    rules={[{ type: 'number', min: 0 }]}
                  >
                    <InputNumber className="form-control w-100" min={0} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'prompts_submitted_for_all_apps']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Prompts Submitted (All Apps)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Prompts Submitted (All Apps)'
                  )}
                  <Form.Item
                    name="prompts_submitted_for_all_apps"
                    label="Prompts Submitted (All Apps)"
                    className="m-0"
                    rules={[{ type: 'number', min: 0 }]}
                  >
                    <InputNumber className="form-control w-100" min={0} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'prompts_submitted_for_copilot_chat_work']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Prompts (Copilot Chat Work)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Prompts (Copilot Chat Work)'
                  )}
                  <Form.Item
                    name="prompts_submitted_for_copilot_chat_work"
                    label="Prompts (Copilot Chat Work)"
                    className="m-0"
                    rules={[{ type: 'number', min: 0 }]}
                  >
                    <InputNumber className="form-control w-100" min={0} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'prompts_submitted_for_copilot_chat_web']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Prompts (Copilot Chat Web)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Prompts (Copilot Chat Web)'
                  )}
                  <Form.Item
                    name="prompts_submitted_for_copilot_chat_web"
                    label="Prompts (Copilot Chat Web)"
                    className="m-0"
                    rules={[{ type: 'number', min: 0 }]}
                  >
                    <InputNumber className="form-control w-100" min={0} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'active_usage_days_for_all_apps']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Active Usage Days (All Apps)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Active Usage Days (All Apps)'
                  )}
                  <Form.Item
                    name="active_usage_days_for_all_apps"
                    label="Active Usage Days (All Apps)"
                    className="m-0"
                    rules={[{ type: 'number', min: 0 }]}
                  >
                    <InputNumber className="form-control w-100" min={0} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_copilot_chat_work_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (Copilot Chat Work)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (Copilot Chat Work)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_copilot_chat_work_utc"
                    label="Last Activity (Copilot Chat Work)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_copilot_chat_web_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (Copilot Chat Web)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (Copilot Chat Web)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_copilot_chat_web_utc"
                    label="Last Activity (Copilot Chat Web)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_teams_copilot_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (Teams Copilot)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (Teams Copilot)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_teams_copilot_utc"
                    label="Last Activity (Teams Copilot)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_word_copilot_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (Word Copilot)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (Word Copilot)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_word_copilot_utc"
                    label="Last Activity (Word Copilot)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_excel_copilot_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (Excel Copilot)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (Excel Copilot)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_excel_copilot_utc"
                    label="Last Activity (Excel Copilot)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_powerpoint_copilot_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (PowerPoint Copilot)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (PowerPoint Copilot)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_powerpoint_copilot_utc"
                    label="Last Activity (PowerPoint Copilot)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_outlook_copilot_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (Outlook Copilot)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (Outlook Copilot)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_outlook_copilot_utc"
                    label="Last Activity (Outlook Copilot)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_onenote_copilot_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (OneNote Copilot)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (OneNote Copilot)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_onenote_copilot_utc"
                    label="Last Activity (OneNote Copilot)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_loop_copilot_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (Loop Copilot)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (Loop Copilot)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_loop_copilot_utc"
                    label="Last Activity (Loop Copilot)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_microsoft_365_copilot_app_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (M365 Copilot App)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (M365 Copilot App)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_microsoft_365_copilot_app_utc"
                    label="Last Activity (M365 Copilot App)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_edge_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (Edge Copilot)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (Edge Copilot)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_edge_utc"
                    label="Last Activity (Edge Copilot)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item
                      name={['checked', 'last_activity_date_of_copilot_agent_utc']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Last Activity (Copilot Agent)</Checkbox>
                    </Form.Item>
                  ) : (
                    'Last Activity (Copilot Agent)'
                  )}
                  <Form.Item
                    name="last_activity_date_of_copilot_agent_utc"
                    label="Last Activity (Copilot Agent)"
                    className="m-0"
                  >
                    <DatePicker className="form-control w-100" disabledDate={disabledDate} />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'date_added']} valuePropName="checked" noStyle>
                      <Checkbox>Date Added</Checkbox>
                    </Form.Item>
                  ) : (
                    'Date Added'
                  )}
                  <Form.Item name="date_added" label="Date Added" className="m-0">
                    <DatePicker className="form-control w-100" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <div className="btns-block modal-footer">
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={o365CopilotUsage.save.loading || commonLookups.save.loading}
              >
                {submitButtonText}
              </Button>
              <Button key="back" onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </>
  );
};
export default AddO365CopilotUsageModal;
